import React from "react";
import { Navigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const isTrue = (key) => {
  const val = secureLocalStorage.getItem("partnerVerified");
  return val === true || val === "true";
};

const MCTProtectedRoute = ({ children }) => {
  // Only check partnerVerified
  if (!isTrue("partnerVerified")) {
    return <Navigate to="/partnerprofile" replace />;
  }

  return children;
};

export default MCTProtectedRoute;
